import { Component, Input, OnInit } from '@angular/core';
import { BmsStateService } from '@app/core/services/bms-state-service';
import { GetCustomerInfoResponse } from '@app/core/xprojector_backend/proto/xprojector.modulebms.customeradmin.pb';
import { XProjectorBmsCustomerAdminClient } from '@app/core/xprojector_backend/xprojector-bms-customeradmin-client';
import { ClrDatagridSortOrder } from '@clr/angular';
import { PageData } from '@xprojectorcore/models/page-data';
import { StateService } from '@xprojectorcore/services/state-service';
import { PortalInteractService } from '@xprojectorfeatures/portal/services/portal-interact.service';
import { NGXLogger } from 'ngx-logger';
import { ArrayUtils, DateHelper, XprojAlertService, XprojModalService } from 'xproj-lib';


@Component({
  selector: 'app-bms-customer-energyshaver',
  templateUrl: './bms-customer-energyshaver.component.html',
  styleUrls: ['./bms-customer-energyshaver.component.scss']
})
export class BmsCustomerEnergyshaverComponent implements OnInit {

  public static PAGEID = 'customerenergyshaver';

  @Input() data: PageData;
  @Input() visible: boolean = false;
  @Input() admin: boolean = false;

  customerInfo : GetCustomerInfoResponse;

  descSort = ClrDatagridSortOrder.DESC;
  ascSort = ClrDatagridSortOrder.ASC;

  constructor(
    private logger: NGXLogger,
    private state: StateService,
    private bmsState: BmsStateService,
    private modalService: XprojModalService,
    private alertService: XprojAlertService,
    public dateHelper: DateHelper,
    private portalInteractService: PortalInteractService,
    private bmsCustomerAdminClient: XProjectorBmsCustomerAdminClient
  ) {

  }

  ngOnInit(): void {
    this.updateCustomerInfo();
  }

  async initPage() {
  }

  async updateCustomerInfo() {
    this.customerInfo = await this.bmsCustomerAdminClient.getCustomerInfo(this.data.customerId);

  }
}
